/**
 *-------------------------------------------
 * apis for all the theme
 *-------------------------------------------
 */

import { postData } from '../../request'

export function fetchAllThemes(body) {
    return postData('/api/getThemeAllPickList/', body)
}

export function fetchBaseThemes(body) {
    return postData('/api/admin/getBaseThemeMap/', body)
}

export function insertBaseThemeMap(body) {
    return postData('/api/admin/insertBaseThemeMap/', body)
}

export function updateBaseThemeMap(body) {
    return postData('/api/admin/updateBaseThemeMap/', body)
}

export function deleteBaseThemeMap(body) {
    return postData('/api/admin/deleteBaseThemeMap/', body)
}

export function fetchClientThemes(body) {
    return postData('/api/admin/getClientThemeMap/', body)
}

export function insertClientThemeMap(body) {
    return postData('/api/admin/insertClientThemeMap/', body)
}

export function updateClientThemeMap(body) {
    return postData('/api/admin/updateClientThemeMap/', body)
}

export function deleteClientThemeMap(body) {
    return postData('/api/admin/deleteClientThemeMap/', body)
}

export function duplicationsThemeCheck(body) {
    return postData('/api/admin/getClientMapCheck/', body)
}
